<template>
  <div class="search">
    <div class="grey lighten-2">
      <v-container class="results">
        <div class="d-flex align-center flex-row flex-wrap">
          <v-btn
            v-if="$platform_is_cordova && toPrevious"
            elevation="0"
            outlined
            dark
            x-small
            :to="{ path: $routerHistory.previous().path }"
            class="back-button px-0"
            aria-label="Torna Indietro"
            ><v-icon medium elevation="0">mdi-chevron-left</v-icon></v-btn
          >
          <h1 class="search-title">
            Hai cercato:<span class="highlight"> {{ query }}</span>
          </h1>
          <h1 class="search-title" v-if="count > 0">: {{ count }} risultati</h1>
        </div>
        <p class="subtitle-1" v-if="filter">in {{ filter }}</p>
        <p class="subtitle-2" v-if="realSearch">
          Avevi cercato
          <a class="real_search">{{ realSearch }}</a>
          ma non ha prodotto risultati.
        </p>
      </v-container>
      <ProductListGrid
        :query="query"
        :barcode="barcode"
        :parentCategoryId="parent_category_id"
        :key="key"
        mode="search"
        @productsCount="updateCount"
        @searchedText="updateRealSearch"
        position="search"
      />
    </div>
    <div v-if="count == 0" class="secondary">
      <ProductListSlider
        title="Scopri le nostre promozioni"
        paginationClass="swiper-pagination-promo"
        class="secondary"
        :key="key"
        :promo="true"
        :shuffle="true"
        position="search_in_promozione"
      />

      <v-container fluid class="white pt-5 pb-8">
        <FooterCardsGrid :cardsName="['serviziSpesa', 'storeLocator']" />
      </v-container>
      <FaqBar />
    </div>
  </div>
</template>
<style scoped lang="scss">
h1 {
  font-size: 28px;
  font-weight: normal;
  .highlight {
    font-weight: bold;
  }
}
.real_search {
  cursor: text;
}
</style>
<script>
import ProductListGrid from "@/components/product/ProductListGrid";
import FaqBar from "@/components/registration/FaqBar";
import FooterCardsGrid from "@/components/cards/FooterCardsGrid.vue";
import ProductListSlider from "@/components/product/ProductListSlider";

import categoryMixins from "~/mixins/category";
import deliveryReactive from "~/mixins/deliveryReactive";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "SearchProducts",
  // props: ["query", "parent_category_id"],
  components: {
    ProductListGrid,
    FaqBar,
    FooterCardsGrid,
    ProductListSlider
  },
  data() {
    return {
      key: 0,
      count: -1,
      query: null,
      barcode: null,
      parent_category_id: null,
      realSearch: null
    };
  },
  mixins: [categoryMixins, deliveryReactive],
  computed: {
    ...mapGetters({
      promoFilter: "category/promoFilter"
    }),
    toPrevious() {
      var _this = this;
      return _this.$routerHistory.hasPrevious();
    }
  },
  methods: {
    historyBack() {
      window.history.back();
    },
    ...mapActions({
      setCategory: "category/setCategory",
      resetFilters: "category/resetFilters"
    }),
    capitalizeFirstLetter(string) {
      return string && string.length
        ? string.charAt(0).toUpperCase() + string.slice(1)
        : "";
    },
    updateCount(count) {
      this.count = count;
    },
    updateRealSearch(searchedText) {
      this.realSearch = this.query;
      this.query = searchedText;
    },
    getQueryParams() {
      this.query = this.$route.query.q;
      this.barcode = this.$route.query.barcode;
      // this.queryLabel = this.$route.query.barcode
      //   ? this.$route.query.barcode
      //   : this.$route.query.q;
      this.parent_category_id = this.$route.query.parent_category_id;
      this.filter = this.$route.query.filter;
    },
    reload() {
      this.$store.dispatch("category/resetFilters");
      this.key = this.key + 1;
    }
  },
  async created() {
    this.getQueryParams();
    await this.resetFilters("q=" + this.query);
  },
  beforeRouteLeave(to, from, next) {
    global.EventBus.$emit("clearSearch");
    next();
  },
  watch: {
    async "$route.query"() {
      this.getQueryParams();
      this.key = this.key + 1;
      this.realSearch = null;
      this.count = null;
      await this.resetFilters("q=" + this.query);
    }
  }
};
</script>
